/* tslint:disable */
import {
  KanvasUser,
  ChatRoom
} from '../index';

declare var Object: any;
export interface ChatMessageInterface {
  "message"?: string;
  "id"?: number;
  "kanvasUserId"?: string;
  "chatRoomId"?: number;
  kanvasUser?: KanvasUser;
  chatRoom?: ChatRoom;
}

export class ChatMessage implements ChatMessageInterface {
  "message": string;
  "id": number;
  "kanvasUserId": string;
  "chatRoomId": number;
  kanvasUser: KanvasUser;
  chatRoom: ChatRoom;
  constructor(data?: ChatMessageInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ChatMessage`.
   */
  public static getModelName() {
    return "ChatMessage";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of ChatMessage for dynamic purposes.
  **/
  public static factory(data: ChatMessageInterface): ChatMessage{
    return new ChatMessage(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'ChatMessage',
      plural: 'ChatMessages',
      path: 'ChatMessages',
      idName: 'id',
      properties: {
        "message": {
          name: 'message',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
        "chatRoomId": {
          name: 'chatRoomId',
          type: 'number'
        },
      },
      relations: {
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
        chatRoom: {
          name: 'chatRoom',
          type: 'ChatRoom',
          model: 'ChatRoom',
          relationType: 'belongsTo',
                  keyFrom: 'chatRoomId',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/ChatMessage.ts